<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="$attrs"
    item-text="tags"
    item-value="id"
    :items="teachers"
    return-object
    multiple
    chips
    hide-selected
    :menu-props="{ closeOnContentClick: false }"
    @change="onChangeMulti"
    v-on:input="$emit('input', $event)"
    clearable
    :loading="loading"
    v-model="selectedTeachers"
    :filter="customFilter"
    hide-no-data
  >
    <template v-slot:selection="{ item }">
      <v-chip v-if="item" :key="item.id" small class="ma-1" close @click:close="removeTeacher(item)">
        {{ item.name || item.code }}
      </v-chip>
    </template>

    <template v-slot:item="{ item }">
      <v-list-item @click.stop="toggleSelect(item)">
        <v-list-item-action>
          <v-checkbox :input-value="isSelected(item)" @change.stop="toggleSelect(item)" ripple />
        </v-list-item-action>

        <v-list-item-content style="max-width: 400px">
          <CardTeacherInfo
            :displayGender="displayGender"
            :teacher="item"
            :displaySubjectGroup="displaySubjectGroup"
            :displayCode="displayCode"
            :displayDob="displayDob"
            :displayStatus="displayStatus"
          />
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import { Teacher } from '@/plugins/api'
import CardTeacherInfo from '@/components/basic/card/CardTeacherInfo.vue'
import unidecode from 'unidecode'
import { isArray } from 'lodash'

export default {
  name: 'AutocompleteTeacherCardMany',
  components: {
    CardTeacherInfo,
  },
  data: () => ({
    teachers: [],
    loading: false,
    selectedTeachers: [],
  }),
  props: {
    filter: Object,
    options: Object,
    defaultTeachers: {
      type: Array,
      default: () => [],
    },
    defaultTeacher: Object,
    displayGender: Boolean,
    displaySubjectGroup: Boolean,
    displayCode: Boolean,
    displayDob: { type: Boolean, default: true },
    displayStatus: Boolean,
    syncedValue: {
      type: [Array, Object, null],
      default: () => [],
    },
  },
  watch: {
    filter() {
      this.fetchAllTeachers()
    },
    syncedValue: {
      handler(value) {
        if (!value) {
          this.selectedTeachers = []
        } else if (isArray(value)) {
          this.selectedTeachers = value
        } else {
          this.selectedTeachers = value ? [value] : []
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    if (this.defaultTeachers && this.defaultTeachers.length) {
      this.teachers = this.defaultTeachers
    }
    this.fetchAllTeachers()
  },
  methods: {
    async fetchAllTeachers() {
      this.loading = true
      try {
        let teachers = await Teacher.fetch({
          ...this.filter,
          _sort: 'nameToNumber:ASC,status:ASC',
          _limit: -1,
        })
        if (this.defaultTeacher) {
          teachers = teachers.filter(item => item.id !== this.defaultTeacher.id)
        }
        teachers.forEach(teacher => {
          teacher.tags = `${unidecode(teacher.name || '')} ${teacher.code || ''}`.toLowerCase()
          teacher._originalName = teacher.name || ''
        })
        this.teachers = teachers
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },

    customFilter(item, queryText = '', itemText) {
      try {
        if (!queryText) return true
        const q = unidecode(String(queryText))
          .toLowerCase()
          .trim()
        const tags = String(item.tags || '').toLowerCase()
        const originalName = String(item._originalName || '').toLowerCase()
        return tags.indexOf(q) !== -1 || unidecode(originalName).indexOf(q) !== -1
      } catch (e) {
        return true
      }
    },

    isSelected(item) {
      if (!item) return false
      return this.selectedTeachers.some(t => t && t.id === item.id)
    },

    toggleSelect(item) {
      if (!item) return
      const foundIndex = this.selectedTeachers.findIndex(t => t && t.id === item.id)
      if (foundIndex !== -1) {
        this.selectedTeachers.splice(foundIndex, 1)
      } else {
        this.selectedTeachers.push(item)
      }
      this.$emit('update:syncedValue', this.selectedTeachers)
      this.$emit('change', this.selectedTeachers)
    },

    removeTeacher(item) {
      const idx = this.selectedTeachers.findIndex(t => t && t.id === item.id)
      if (idx !== -1) {
        this.selectedTeachers.splice(idx, 1)
        this.$emit('update:syncedValue', this.selectedTeachers)
        this.$emit('change', this.selectedTeachers)
      }
    },

    onChangeMulti(val) {
      this.selectedTeachers = Array.isArray(val) ? val : []
      this.$emit('update:syncedValue', this.selectedTeachers)
      this.$emit('change', this.selectedTeachers)
    },
  },
}
</script>
